import React from 'react'

// components
import InputField from '../../InputField/InputField.component'

// mui
import { Box, Typography, Grid, Paper } from '@mui/material'

import './ProcessEquipmentRequestItemInput.css'

export default function ProcessEquipmentRequestItemInput({ stage = 0, equipmentName, requestedQuantity, sentQuantity, maxQuantity, note, handleChange, prefix, errors }) {

    return (<Box component={Paper} sx={{ padding: 2, marginBottom: 4}}>
        <Grid container>
            <Grid container columns={2} >
                <Grid item xs={4}><Typography variant='h6'>{equipmentName}</Typography></Grid>
                <Grid item xs={8} sx={{ color: "sentQuantity" in errors && !errors[sentQuantity] ? "red" : "gray", textAlign: 'right'}}>
                    {
                        stage === 0 ? `Max: ${maxQuantity} - Requested: ${requestedQuantity}` : `Shipped: ${sentQuantity}`
                    }
                </Grid>
            </Grid>
        </Grid>

        <div>
            {
                stage == 0 &&
                
                <div className='process-equipment-request-item-input-row'>
                    <InputField
                        id={`${prefix}.sentQuantity`}
                        type="text"
                        placeholder='Qty Shipped'
                        onChange={handleChange}
                        value={sentQuantity}
                        isValid={errors['sentQuantity']}
                    />
                    <InputField
                        id={`${prefix}.note`}
                        type="textarea"
                        placeholder='Notes'
                        onChange={handleChange}
                        value={note}
                        required={false}
                        isValid={errors['note']}
                    />
                </div>
            }
        </div>
        </Box>)
}